<template>
  <div :class="['footer-wrapper', isShowOtherFooter ? 'other-wrapper' : '']">
    <footer>
      <div v-if="isShowOtherFooter"></div>
      <div class="left">
        <dt>{{ $t("title.contact") }}</dt>
        <dd>
          <i class="iconfont icon-dianhua"></i>
          <span>{{ $store.state.contactUsData.FPhone }}</span>
        </dd>
        <dd>
          <i class="iconfont icon-duanxinqunfa"></i>
          <span>{{ $store.state.contactUsData.Email }}</span>
        </dd>
        <dd>
          <i class="iconfont icon-ditu_dingwei"></i>
          <span>{{ formatAdress($store.state.contactUsData) }}</span>
        </dd>
      </div>

      <div class="right">
        <dt>{{ $t("title.aboutUs") }}</dt>
        <dd>
          <div class="img-wrap">
            <i>Alibaba</i>
            <img :src="$store.state.contactUsData.WebSite" alt="" />
          </div>
          <div class="img-wrap">
            <i>Wechat</i>
            <img :src="erweima2" alt="" />
          </div>
        </dd>
      </div>
    </footer>
    <!-- <p>
      Network Culture Business License Zhengjiang Net Wen {2019} No. 3802-272
    </p> -->
    <p>
      <a href="https://beian.miit.gov.cn" target="_blank"
        >ICP备2020032380号-1</a
      >
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowOtherFooter: false,
      erweima2: ""
    };
  },
  mounted() {
    // 公司信息
    const params = {
      Data: {
        FInterID: 3
      }
    };
    this.$store.dispatch("getIndexBodyData", params);

    // 后期新增了一张二维码
    const params2 = {
      Data: {
        FInterID: 9
      }
    };
    this.$store.dispatch("getIndexBodyData", params2).then(res => {
      this.erweima2 = res.Data.WebSite;
    });
  },
  methods: {
    formatAdress(item) {
      let adress;
      if (this.$i18n.locale === "zh") {
        adress = item.Adress;
      } else if (this.$i18n.locale === "en") {
        adress = item.EnglishAdress;
      } else if (this.$i18n.locale === "sp") {
        adress = item.xibanyaAdress;
      }
      return adress;
    }
  },
  watch: {
    $route: {
      handler: function() {
        if (this.$route.name === "NewsDetails") {
          this.isShowOtherFooter = true;
        } else {
          this.isShowOtherFooter = false;
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/variables.less";
.footer-wrapper {
  width: 100%;
  height: 396px;
  background: url("../../../assets/imgs/c-footer-bg.png") top center no-repeat;
  background-size: 100% 100%;

  footer {
    width: 1200px;
    height: 356px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    text-align: left;

    .left,
    .right {
      flex: 1;
      height: 100%;

      dt {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 100px;
      }
    }

    .left {
      dd {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .iconfont {
          font-size: 36px;
          margin-right: 33px;
        }

        span {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          width: 307px;
          line-height: 21px;
        }
      }
    }

    .right {
      text-align: center;

      dd {
        display: flex;
        align-items: center;
        justify-content: center;

        .img-wrap {
          i {
            display: block;
            margin-bottom: 16px;
            position: relative;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
          }

          i::before {
            content: "";
            display: block;
            width: 36px;
            height: 36px;
            background: url("../../../assets/imgs/wechat.png") top center
              no-repeat;
            background-size: 100% 100%;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }

          img {
            display: block;
            width: 158px;
            height: 158px;
          }
        }

        .img-wrap:first-child {
          margin-right: 30px;

          i::before {
            content: "";
            display: block;
            width: 36px;
            height: 36px;
            background: url("../../../assets/imgs/alibaba.png") top center
              no-repeat;
            background-size: 100% 100%;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }

  p {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff;

    a {
      color: #fff;
    }
  }
}

.other-wrapper {
  width: 100%;
  height: 396px;
  background: url("../../../assets/imgs/c-footer-bg-2.png") top center no-repeat;
  background-size: 100% 100%;

  footer {
    width: 100%;
    height: 356px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #fff;

    div {
      flex: 1;
    }

    .left,
    .right {
      height: 100%;

      dt {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 100px;
      }
    }

    .left {
      dd {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .iconfont {
          font-size: 36px;
          margin-right: 33px;
        }

        span {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          width: 307px;
          line-height: 21px;
        }
      }
    }

    .right {
      dd {
        display: flex;
        align-items: center;
        justify-content: center;

        .img-wrap {
          i {
            margin-bottom: 16px;
            position: relative;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            text-align: left;
            padding-left: 40px;
          }

          i::before {
            content: "";
            width: 36px;
            height: 36px;
            background: url("../../../assets/imgs/wechat.png") top center
              no-repeat;
            background-size: 100% 100%;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }

          img {
            display: block;
            width: 158px;
            height: 158px;
          }
        }

        .img-wrap:first-child {
          margin-right: 30px;

          i::before {
            content: "";
            width: 36px;
            height: 36px;
            background: url("../../../assets/imgs/alibaba.png") top center
              no-repeat;
            background-size: 100% 100%;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }

  p {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff;
  }
}
</style>
